import { setSortingDocumentation } from '../../action';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = {
  field: 'id',
  type: 'desc'
};

export default createReducer(
  [forAction(setSortingDocumentation, identityPayload)],
  initialState,
);
